<template>
	<v-container grid-list-md>
		<ValidationObserver ref="obs" v-slot="{ invalid }">
			<v-form>
				<v-card>
					<v-card-subtitle>
						<Link
							as="v-btn"
							:href="
								$route(
									'tenant.profile.index',
									$page.props.tenant.id
								)
							"
							>{{ $t("title.profile") }}</Link
						>
						<Link
							as="v-btn"
							:href="
								$route(
									'tenant.profile.password.index',
									$page.props.tenant.id
								)
							"
							:value="true"
							color="primary"
							>{{ $t("title.password") }}</Link
						>
					</v-card-subtitle>
					<v-card-title primary-title>
						{{ $t("title.password") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12>
								<ValidationProvider
									name="password"
									rules="required|min:8"
									v-slot="{ errors, valid }"
								>
									<v-text-field
										v-model="item.password"
										:label="$t('label.password')"
										prepend-icon="mdi-lock"
										type="password"
										:error-messages="errors"
										:append-icon="
											valid ? 'mdi-check' : null
										"
									></v-text-field>
								</ValidationProvider>
							</v-flex>
							<v-flex xs12>
								<ValidationProvider
									name="password_confirmation"
									rules="required|min:8"
									v-slot="{ errors, valid }"
								>
									<v-text-field
										:label="
											$t('label.password_confirmation')
										"
										v-model="item.password_confirmation"
										prepend-icon="mdi-lock"
										type="password"
										:error-messages="errors"
										:append-icon="
											valid ? 'mdi-check' : null
										"
									></v-text-field>
								</ValidationProvider>
							</v-flex>
						</v-layout>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="primary"
							@click.native="submit()"
							:loading="item.processing"
							:disabled="invalid"
						>
							<v-icon left>mdi-content-save</v-icon>
							{{ $t("Update") }}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</ValidationObserver>
	</v-container>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
export default {
	components: {
		Link,
	},
	props: {
		auth: Object,
	},

	data() {
		return {
			item: this.$inertia.form({
				password: null,
				password_confirmation: null,
			}),
		};
	},

	methods: {
		submit() {
			this.item.post(
				this.$route(
					"tenant.profile.password.store",
					this.$page.props.tenant.id
				),
				{
					onFinish: () => location.reload(),
				}
			);
		},
	},
};
</script>